const arrowSelectors = [
	'.slider-control-centerleft',
	'.slider-control-centerright'
];

const ctaSelector = '.cta-container';
const toolbarSelector = '.media-gallery-toolbar';

const changeElementVisibility = (selector, visibility) => {
	const el = document.querySelector(selector);
	if (el) {
		setTimeout(() => {
			el.style.visibility = visibility;
		}, 0);
	}
};

export const hideElement = (selector) => {
	changeElementVisibility(selector, 'hidden');
};

export const showElement = (selector) => {
	changeElementVisibility(selector, 'visible');
};

const doHtmlSlide = (isMobile) => {
	arrowSelectors.forEach((selector) => {
		showElement(selector);
	});
	hideElement(ctaSelector);
	if (!isMobile) {
		hideElement(toolbarSelector);
	}
};

const doImageSlide = (isMobile) => {
	showElement(toolbarSelector);
	showElement(ctaSelector);
	arrowSelectors.forEach((selector) => {
		if (isMobile) {
			hideElement(selector);
		} else {
			showElement(selector);
		}
	});
};

export const showHideGalleryControls = (isMobile) => {
	doHtmlSlide(isMobile);
};

export const handleGalleryToolbarVisibility = (images, index, isMobile) => {
	if (!images[index]) {
		return;
	}

	// If image slide
	if (images[index].type !== 'html') {
		doImageSlide(isMobile);
		return;
	}

	// If HTML slide
	window.requestAnimationFrame(() => {
		const { src } = images[index];
		const image = document.querySelector(
			`.slide.slide-visible img[src="${src}"]`
		);

		if (!image || image.classList.contains('pswp-thumbnail')) {
			return;
		}

		if (
			image.getAttribute('data-wiapi-placeholder-content') &&
			image.style.display === 'none'
		) {
			doHtmlSlide(isMobile);
		} else {
			doImageSlide(isMobile);
		}
	});
};
